import {useSelector} from "react-redux";
import PropTypes from "prop-types";

import {accessAllowed} from "../../gitIgnore/accessAllowedIds";
import {getCurrentUser} from "../../slices/UserSlice";
import {ROLES} from "../../utilities/generalConstants.js/generalConstants";

const AccessBoundary = ({roles, children, itManagerOnly = false}) => {
  const user = useSelector(getCurrentUser);

  const access =
    (itManagerOnly && accessAllowed?.includes(user?.id)) ||
    (!itManagerOnly &&
      (roles?.includes(user?.position?.positionId) || user?.position?.positionId === ROLES.SUPER_USER));

  return <>{access ? children : null}</>;
};

AccessBoundary.propTypes = {children: PropTypes.node};

export default AccessBoundary;
